import { render, staticRenderFns } from "./AseguradoraPrestador.vue?vue&type=template&id=1e99f8be&scoped=true"
import script from "./AseguradoraPrestador.vue?vue&type=script&lang=js"
export * from "./AseguradoraPrestador.vue?vue&type=script&lang=js"
import style0 from "./AseguradoraPrestador.vue?vue&type=style&index=0&id=1e99f8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e99f8be",
  null
  
)

export default component.exports